import { render, staticRenderFns } from "./leftcard1.vue?vue&type=template&id=b5992bf4&scoped=true"
import script from "./leftcard1.vue?vue&type=script&lang=js"
export * from "./leftcard1.vue?vue&type=script&lang=js"
import style0 from "./leftcard1.vue?vue&type=style&index=0&id=b5992bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5992bf4",
  null
  
)

export default component.exports